<style lang="scss" src="./component.scss"></style>

<template>
  <header class="app-header">
    <div class="app-header__logo-wrapper">
      <a
        class="app-header__logo"
        href="/?utm_source=bork_app&utm_medium=referral&utm_campaign=web_landing"
        target="_blank"
      />
      <div class="app-header__logo-divider" />
      <p
        class="app-header__logo-text"
        v-html="$t('header.mobileApp')"
      />
    </div>
  </header>
</template>

<script>
  import { DeviceDetector } from '@/utils/device-detector';
  import { storeLogos } from '@/assets/logo';

  export default {
    name: 'app-header',
    data() {
      return {
        storeLogos: storeLogos(),
        isMobile: DeviceDetector.isMobile()
      };
    }
  };
</script>
